import React, { FC, useCallback, useState } from 'react';
import { Accordion } from '@components/UIKit/Accordion/Accordion';
import { Header } from '@components/Pages/ToyPage/AccordionItems/Header';
import { Body } from '@components/Pages/ToyPage/AccordionItems/Body';
import { useTranslation } from '@hooks/useTranslation';
import { collectionMeta } from '@specs/specs';
import s from './collectionSection.module.scss';
import parse from 'html-react-parser';
import { StatsItem } from '@components/Cards/StatsItem/StatsItem';
import { formatWithSpaces } from '@specs/helpers';
import { useGetCollectionEarningsCount } from '@hooks/TRPC_Hooks/useGetCollectionEarningsCount';
import { useSession } from 'next-auth/react';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
import { LinksEnum } from '@specs/navigation';
import { useRouter } from 'next/router';
interface Props {
  collection: collectionMeta | null | undefined;
}
export const CollectionSection: FC<Props> = ({
  collection
}) => {
  const {
    status
  } = useSession();
  const {
    translate: tr
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const {
    data: earned,
    isLoading: earnedLoading
  } = useGetCollectionEarningsCount({
    collectionId: collection?.id ?? -1,
    includeBonus: false
  }, {
    retry: 3,
    enabled: !!collection && isOpen
  });
  const isLoading = status === 'authenticated' && earnedLoading;
  const handleCLickOnImage = useCallback(async () => {
    if (collection) {
      await router.push({
        pathname: LinksEnum.EXPLORE_COLLECTION,
        query: {
          slug: collection.id
        }
      });
    }
  }, [collection, router]);
  return <Accordion toggler={<Header onClick={() => {
    setIsOpen(prev => !prev);
  }} isOpen={isOpen} isDisabled={!collection}>
                    {tr({
      id: 'toy.page.collection.title'
    })}
                </Header>} isOpen={isOpen} data-sentry-element="Accordion" data-sentry-component="CollectionSection" data-sentry-source-file="CollectionSection.tsx">
            <Body data-sentry-element="Body" data-sentry-source-file="CollectionSection.tsx">
                {collection && <div className={s.collectionSection}>
                        <OptimizedImage boxClassName={s.collectionSection__image} path={'/collection-meta'} cdnId={collection.imageid} alt={`collection: ${collection.name}`} style={{
          cursor: 'pointer'
        }} fill onClick={handleCLickOnImage} />
                        <div className={s.collectionSection__main}>
                            <div className={s.collectionSection__name}>
                                {collection.name}
                            </div>
                            <div className={s.collectionSection__description}>
                                {parse(collection.description)}
                            </div>
                        </div>
                        <div className={s.collectionSection__stats}>
                            <StatsItem value={formatWithSpaces(earned ?? 0)} text={tr({
            id: 'toy.page.collection.stats.collected'
          })} isLoading={isLoading} />
                            <StatsItem value={formatWithSpaces(collection.toysTotal)} text={tr({
            id: 'toy.page.collection.stats.toys'
          })} />
                        </div>
                    </div>}
            </Body>
        </Accordion>;
};